import { Injectable } from '@angular/core';

import { ApiService, LogService, UserService, AppContext } from './../../';
import { PersonalInformation } from './../../models';
declare const moment: any;

@Injectable()
export class PersonalInformationService {
  firstName: string = '';
  firstNameError: string = '';

  lastName: string = '';
  lastNameError: string = '';

  company: string = '';
  companyError: string = '';

  position: string = '';
  positionError: string = '';

  business: string = '';
  businessError: string = '';

  businessChoices: Array<string> = [
    'Select a Business',
    'Freight Forwarder',
    'Network or Association of Freight Forwarders',
    'Non-Vessel Operating Common Carrier (NVOCC)',
    'Vessel Operating Common Carrier (VOCC)',
    'Customs Agent, Liner Agent, Broker',
    'Port Authority, Terminal Operator, Inland Depot Agent',
    'Intermodal Operator, Trucking Company, Railroad',
    'Container Manufacture, Repair, Handling, Leasing',
    'Insurance, Banking, Accounting, Consulting, Government',
    'Shipper, Consignee, Importer, Exporter',
    'Other'
  ];
  businessChoice: string = this.businessChoices[0];

  city: string = '';
  cityError: string = '';

  country: string = '';
  countryError: string = '';

  frontError: boolean = false;
  status: string = '';
  message: string = '';

  constructor(private api: ApiService, private logger: LogService, private user: UserService, public app: AppContext) {
    this.init();
  }

  init(): void {
    if (this.app.personalInformation == null) {
      this.user.getProfile().then(() => {
        this.populateFromUserProfile();
      });
    } else {
      this.populateFromUserProfile();
    }
  }

  getPersonalInformation(): Promise<PersonalInformation> {
    return new Promise((resolve, reject) => {
      this.user.getProfile().then(() => {
        resolve(this.app.personalInformation);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  populateFromUserProfile(): void {
    if (this.app.personalInformation != null) {
      this.firstName = this.app.personalInformation.firstName;
      this.lastName = this.app.personalInformation.lastName;
      this.company = this.app.personalInformation.company || '';
      this.position = this.app.personalInformation.position || '';
      this.business = this.app.personalInformation.business || '';

      let index = this.businessChoices.indexOf(this.business);
      if (this.business == '') {
        this.businessChoice = this.businessChoices[0];
      } else if (index > -1) {
        this.businessChoice = this.businessChoices[index];
      } else {
        this.businessChoice = 'Other';
      }

      this.city = this.app.personalInformation.city || '';
      this.country = this.app.personalInformation.country || '';
    }
  }

  save(model: PersonalInformation): Promise<any> {
    this.logger.log('personal-information.service', 'save model', model);

    if (this.status !== 'saving') {
      this.status = 'saving';

      return new Promise((resolve, reject) => {
        this.user.addPersonalInformation(model).then(result => {
          this.logger.log('personal-information.service', 'add personal information result', result);
          this.status = 'saved';
          this.app.setPersonalInformation(model);
          resolve(result);
        }).catch(err => {
          this.logger.log('personal-information.service', 'save error', err);
          this.status = 'error';
          this.message = err.message;
          reject(err);
        });
      });
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/components/personal-information/personal-information.service.ts